function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { FaTimes } from 'react-icons/fa';
import { cmsActions } from '../../reducers/cms.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import AssetThumbnail from './AssetThumbnail.react';

// TODO :: call by id to retrieve 1
// TODO :: add placeholder for input
var AssetViewer = function AssetViewer(_ref) {
  var _ref$type = _ref.type,
    pType = _ref$type === void 0 ? null : _ref$type,
    hideModalAction = _ref.hideModalAction,
    assetsAction = _ref.assetsAction,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? null : _ref$onSelect;
  var cmsAssets = useSelector(function (s) {
    return s.cms.assets || {};
  });
  useEffect(function () {
    assetsAction({});
  }, []);
  var _useState = useState({
      type: pType
    }),
    _useState2 = _slicedToArray(_useState, 1),
    state = _useState2[0];
  var type = state.type;
  return /*#__PURE__*/React.createElement("div", {
    className: "asset-viewer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "asset-viewer__close",
    onClick: function onClick() {
      hideModalAction();
    }
  }, /*#__PURE__*/React.createElement(FaTimes, null)), /*#__PURE__*/React.createElement("div", {
    className: "asset-viewer__body"
  }, Object.values(cmsAssets).filter(function (x) {
    return !type || x.type === type;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement(AssetThumbnail, _extends({}, x, {
      onClick: function onClick() {
        if (onSelect) onSelect(x);
        hideModalAction();
      },
      key: "a-viewer-".concat(x._id)
    }));
  })));
};
var mdtp = {
  assetsAction: cmsActions.assets,
  hideModalAction: modalActions.hide,
  contactsAction: cmsActions.contacts
};
export default connect(null, mdtp)(AssetViewer);